"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCarrierData = void 0;
function getCarrierData(id, carriersData) {
    return carriersData?.find(carrier => carrier?.carrier_ezlynx_id?.toString() === id);
}
exports.getCarrierData = getCarrierData;
